// extracted by mini-css-extract-plugin
export default {"rulesButton":"rulesButton-M1eWimkI"};